import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Button, TextField } from "@mui/material";

import { useUserData } from "src/context/userContext";
import { useKeikkaData } from "src/context/KeikkaDataContext";
import { addStepLogMessage } from "src/data/keikka/handleKeikka";
import { keikka_otsikko_save_to_db } from "src/data/keikka/KeikkaFunctions";

import { SaveIcon } from "src/components/icons/ActionIcons";
import { socketOnSave } from "src/data/system/socketClass";

const styles = {
  height45: { height: "45px" },
  pointer: { cursor: "pointer" },
};

export default function KeikkaOtsikkoInput(props) {
  const { keikkaData, doSetKeikkaData: setKeikkaData } = useKeikkaData();
  const onEditEnd = props.onEditEnd;
  const { user, token, socket } = useUserData();
  const otsikkoTextRef = useRef(null);
  const otsikkoDivRef = useRef(null);
  const nullOtsikko = "tilauksen otsikko";

  const [originalOtsikko, setOriginalOtsikko] = useState(keikkaData.keikkaOtsikko);

  useEffect(() => {
    setOriginalOtsikko(keikkaData.keikkaOtsikko);
    // focus
    otsikkoTextRef.current.focus();
  }, []);

  const handleClickOutside = (event) => {
    if (otsikkoDivRef.current && !otsikkoDivRef.current.contains(event.target)) {
      onSaveClick();
    }
  };

  const onSaveClick = async () => {
    document.removeEventListener("click", handleClickOutside, true);
    onEditEnd();
    if (keikkaData.keikkaOtsikko !== originalOtsikko) {
      const personId = user.personId;
      await keikka_otsikko_save_to_db(keikkaData, token);

      // send socket event
      const s = new socketOnSave(
        personId,
        socket,
        keikkaData.ownerAsiakasId,
        "keikkaData",
        "save",
        keikkaData.keikkaId
      );
      s.keikkaId = keikkaData.keikkaId;
      s.keikkaData = keikkaData;
      s.emitSave();

      addStepLogMessage(
        keikkaData,
        socket,
        personId,
        { title: "Tilaus:" + keikkaData.keikkaId, body: "Otsikko:" + keikkaData.keikkaOtsikko },
        13,
        true
      );
      setOriginalOtsikko(keikkaData.keikkaOtsikko);
    }
  };

  const onTextChange = (event) => {
    const otsikko = event.target.value;
    keikkaData.keikkaOtsikko = otsikko;
    setKeikkaData(keikkaData);
  };

  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      // enter
      e.preventDefault();
      onSaveClick();
    }
  };

  return (
    <div ref={otsikkoDivRef} className="center" style={styles.height45}>
      <TextField
        fullWidth
        variant="outlined" //"standard"
        id="KeikkaOtsikko"
        inputRef={otsikkoTextRef}
        onChange={(e) => onTextChange(e)}
        defaultValue={keikkaData.keikkaOtsikko}
        inputProps={{ maxLength: 50 }}
        onKeyDown={onKeyDown}
        className="noPrint transitionElement"
        label={nullOtsikko}
        size="small"
      />
      <div className="noPrint">
        <Button onClick={onSaveClick} aria-label="Tallenna">
          <SaveIcon />
        </Button>
      </div>
    </div>
  );
}

KeikkaOtsikkoInput.propTypes = {
  onEditEnd: PropTypes.func,
};
